export const CFG = {
    classes: { hidden: 'd-none', error: 'error' },
    ids: {
        patientDd: '#patient-dropdown',
        stateDd: '#state-dropdown',
        reminderDd: '#reminder-dropdown'
    },
    selectors: {
        calendar: '#calendar',
        priceRow: '.book__pricesRow',
        priceBox: '.book__prices',
        priceStd: '[data-price]',
        priceDefault: '[data-price-default]',
        priceVeteran: '[data-price-veteran]',
        priceRenewal: '[data-price-renewal]',
        priceTransfer: '[data-price-transfer]',
        uploadListItem: '#uploadList .book__uploadItem',
    },
    values: { returning: 'return-patient', newcomer: 'new-patient' }
};